<template>
  <multiselect
    v-model="selected"
    @input="onChange"
    :options="options"
    :custom-label="label"
    selectLabel=""
    selectedLabel="«"
    deselectLabel=""
    :allowEmpty="true"
    :preselectFirst="true"
    :loading="isLoading"
    :label="$t('Nome')"
    track-by="id"
    :disabled="isDisabled"
    placeholder=""
    :multiple="isMultiple"
    :hide-selected="true"
    :close-on-select="isCloseOnSelect"
    class="multiselect-primary"
    :preserve-search="isPreserveSearch"
    :clear-on-select="isClearOnSelect"
  >
    <template slot="noResult">
      <span>{{ $t('Nenhum elemento encontrado') }}.</span>
    </template>
    <template slot="noOptions">
      <span>{{ $t('Nenhum dado foi retornado') }}.</span>
    </template>
    <template slot="placeholder">
      <span>{{ $t(emptyLabel) }}</span>
    </template>
    <template slot="tag" slot-scope="{ option, remove }">
      <span class="badge badge-primary mr-1">
        <span class="text-truncate mr-1 mb-1">
          {{ `${option.id}-${option.nome}` }}
        </span>
        <span class="custom__remove badge" @mousedown.prevent.stop="remove(option)"> x </span>
      </span>
    </template>
  </multiselect>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';
export default {
  components: {
    Multiselect
  },
  props: {
    esporteFilter: {},
    nameField: {},
    isRequired: { type: Boolean, default: false },
    isDisabled: { type: Boolean, default: false },
    emptyLabel: { type: String, default: null },
    includeAll: { type: Boolean, default: false },
    isMultiple: { type: Boolean, default: false },
    reload: {},
    excludeGroups: {},
    idEsporte: {},
    showSportName: { type: Boolean, default: false },
    isCloseOnSelect: { type: Boolean, default: true },
    isPreserveSearch: { type: Boolean, default: false },
    isClearOnSelect: { type: Boolean, default: true }
  },

  data() {
    return {
      selected: new Array(),
      options: new Array(),
      isLoading: false
    };
  },

  methods: {
    onChange(e) {
      this.$emit('input', e);
      if (e == null) {
        this.$emit('selectChange', 'id_grupo_origem', null);
        return;
      }

      if (this.isMultiple) {
        let arr = new Array();
        e.forEach((el) => {
          arr.push(el.id);
        });
        this.$emit('selectChange', 'id_grupo_origem', arr);
      } else {
        this.$emit('selectChange', 'id_grupo_origem', e.id);
      }
      this.$emit('focus');
    },
    label({ nome, id, nome_esporte }) {
      if (this.isMultiple) {
        if (this.showSportName) {
          return `${id} - ${nome} - ${nome_esporte}`;
        } else {
          return `${id} - ${nome}`;
        }
      } else {
        return nome;
      }
    },
    setValue(value) {
      if (this.isMultiple) {
        this.selected = new Array();
        if (value) {
          value.forEach((el) => {
            this.selected.push(this.options.find((option) => option.id === el));
          });
        } else {
          this.selected = this.options.find((option) => option.id === null);
        }
      } else {
        if (value) {
          this.selected = this.options.find((option) => option.id === value);
          this.reload ? this.$emit('selectChange', 'id_grupo_origem', this.selected.id) : null;
        } else {
          this.selected = this.options.find((option) => option.id === null);
        }
      }
      this.$emit('input', this.selected);
    },
    setOptions(value = null, idEsporte = null) {
      this.isLoading = true;

      if (this.esporteFilter) {
        idEsporte = this.esporteFilter;
      }

      const filtro = idEsporte ? `id_tipo_esporte = ${idEsporte} ` : null;

      this.$atenaList
        .getCommon('grupo_origem', {
          columns: 'id, nome',
          filter: filtro,
          related: 'esporte:nome as nome_esporte',
          order: 'nome',
          limit: -1
        })
        .then((res) => {
          this.options = [];
          if (this.includeAll) {
            this.options = [{ id: null, nome: this.$i18n.t(this.emptyLabel) }];
          }
          this.options = this.options.concat(res.data);

          if (this.excludeGroups) {
            this.options = this.options.filter((e) => {
              return !this.excludeGroups.includes(e.id);
            });
          }
          this.setValue(!value ? this.nameField : value);
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.$notify({
            group: 'notifications-default',
            type: 'error',
            title: this.$i18n.t('Erro ao Carregar Dados'),
            text: this.$i18n.t('Entre em contato com o Administrador do Sistema.')
          });
        });
    }
  },
  created() {
    this.setOptions();
  },
  watch: {
    nameField(value) {
      this.setValue(value);
    },
    reload: function (value) {
      this.setOptions(value);
    },
    idEsporte: function (value) {
      this.setOptions(null, value);
    }
  }
};
</script>

<style lang="scss" scoped></style>
